exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._1f6d0{background-color:#e8182f;height:32px;height:2rem;padding:0 16px;padding:0 1rem}._3cEZt{position:relative;height:100%;width:100%}._3fqFQ{display:flex;width:95%}._6MFAv{width:6%;top:1px}._6MFAv,.NYfs3{position:relative;overflow:hidden}.NYfs3{left:5px;white-space:nowrap;width:92%}._2V9bC{padding:5px;position:absolute;right:8px;top:.6px;font-size:14px}._6MFAv img{width:19.2px;width:1.2rem;height:19.2px;height:1.2rem;position:relative;top:4.3px}._33w75{position:relative;display:inline-block;font-size:12px;top:1px;-webkit-transform:translateX(100%);transform:translateX(100%);-webkit-animation:_3_mMG 10s linear infinite;animation:_3_mMG 10s linear infinite}@-webkit-keyframes _3_mMG{0%{-webkit-transform:translateX(100%)}to{-webkit-transform:translateX(-100%)}}@keyframes _3_mMG{0%{-webkit-transform:translateX(100%);transform:translateX(100%)}to{-webkit-transform:translateX(-100%);transform:translateX(-100%)}}", ""]);

// exports
exports.locals = {
	"containerNotification": "_1f6d0",
	"wrapperContainer": "_3cEZt",
	"wrapperLeftContainer": "_3fqFQ",
	"wrapperLeft": "_6MFAv",
	"wrapperLeft2": "NYfs3",
	"wrapperClosed": "_2V9bC",
	"iconLive": "_2jdFC",
	"descriptionLive": "_33w75",
	"example1": "_3_mMG"
};